import styled from '@emotion/styled';
import CheckIcon from '@/public/icons/check.svg';
import { CSSProperties } from 'react';

interface CustomCheckBoxProps {
  checked: boolean;
  onClick?: () => void;
  disabled?: boolean;
  style?: CSSProperties;
}

const CustomCheckBox = ({
  checked,
  onClick,
  disabled,
  style,
}: CustomCheckBoxProps) => {
  return (
    <Container
      checked={checked}
      onClick={onClick}
      disabled={disabled}
      style={style}
    >
      {
        <CheckIcon
          style={{ color: !checked && disabled ? '#F9FAFB' : 'white' }}
        />
      }
    </Container>
  );
};
export default CustomCheckBox;

const Container = styled.button<{ checked?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  background-color: ${({ checked }) => (checked ? '#06C' : 'var(--dk-bg, white)')};
  border: 1px solid ${({ checked }) => (checked ? '#06C' : '#b7bbc2')};
  cursor: pointer;
  padding: 0;

  &:hover {
    border: ${({ checked }) => (checked ? 'none' : '1px solid #06c')};
    background-color: ${({ checked }) =>
      checked ? 'rgba(0, 102, 204, 0.64)' : 'var(--dk-bg-subtle, #F9FAFB)'};
    box-shadow: ${({ disabled }) =>
      disabled ? 'none' : '0 0 0 2px rgba(0, 102, 204, 0.24)'};
  }

  &:active {
    background: ${({ checked }) =>
      checked ? 'rgba(0, 102, 204, 0.24)' : 'rgba(0, 102, 204, 0.64)'};
    border: none;
    box-shadow: none;
  }

  &:disabled {
    background: ${({ checked }) => (checked ? 'var(--dk-bg-strong, #D1D8E2)' : 'var(--dk-bg-subtle, #F9FAFB)')};
    border: ${({ checked }) => (checked ? 'none' : '1px solid #D1D8E2')};
  }
`;
